export default "__VITE_ASSET__C5Zj4l0r__"